import _objectSpread from "C:/Users/amirs/Documents/Projects/top-menu-panel/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.function.name.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters, mapState } from "vuex";
export default {
  name: "FormDetails.vue",
  components: {},
  data: function data() {
    return {
      username: "",
      selectedPriority: false,
      selectedDepartment: false,
      departments: [{
        id: "technical",
        name: "پشتیبانی فنی"
      }, {
        id: "financial",
        name: "امور مالی و حسابداری"
      }, {
        id: "supervision",
        name: "واحد نظارت و اطلاع رسانی"
      }],
      priorities: [{
        id: "high",
        name: "زیاد"
      }, {
        id: "medium",
        name: "متوسط"
      }, {
        id: "low",
        name: "کم"
      }]
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters({
    currentProvider: "profile/currentProvider"
  })), mapState({
    myProfile: function myProfile(state) {
      return state.profile.myProfile.data;
    }
  })),
  mounted: function mounted() {
    this.username = this.myProfile.name;
  },
  methods: {
    getData: function getData() {
      return {
        username: this.username,
        priority: this.selectedPriority,
        department: this.selectedDepartment
      };
    }
  }
};